<div class="doctor-notes-container">
  <div class="page-title__bar">
    <div>
      <h4 class="title">Check LCD Coverage</h4>
    </div>
  </div>

  <div style="display: flex">
    <div class="half-width">
      <div class="section-block">
        <ng-container>
          <div class="section-header">
            <i class="fas fa-file-medical"></i>
            <span>Enter CPT Code</span>
          </div>
          <input
            type="text"
            [(ngModel)]="cptCode"
            placeholder="Enter CPT code here..."
            class="form-control input-nice"
            pattern="[0-9]*"
            inputmode="numeric"
            maxlength="10"
            (keydown)="allowOnlyNumbers($event)"
            (blur)="onCptBlur()"
          />
          <div class="payer-heading" style="margin-top:10px; margin-bottom:2px; font-weight:600; color:#073786; font-size:1rem;">
            Payer
          </div>
          <select class="form-control input-nice" [(ngModel)]="selectedPayer" (change)="onPayerChange()">
            <option value="" disabled [selected]="!selectedPayer">Select Payer</option>
            <option *ngFor="let payer of payers" [value]="payer">{{ payer }}</option>
          </select>
        </ng-container>
        <ng-template>
          <div class="section-header">
            <i class="fas fa-file-medical"></i>
            <span>CPT Code</span>
          </div>
          <div class="readonly-field">{{ cptCode }}</div>
          <div class="section-header" style="margin-top:10px;">
            <i class="fas fa-user-md"></i>
            <span>Payer</span>
          </div>
          <div class="readonly-field">{{ selectedPayer }}</div>
        </ng-template>
      </div>
      <div class="section-block">
        <div class="section-header">
          <i class="fas fa-file"></i>
          <span>Select Policy Document</span>
        </div>
        <div class="upload-label">
          <select class="form-control input-nice" [(ngModel)]="selectedLcdFileId">
            <option value="" disabled [selected]="!selectedLcdFileId">Select an LCD policy document <strong *ngIf="selectedPayer" style="color:rgb(43, 127, 244);">For {{this.selectedPayer}}</strong></option>
          
            <option *ngFor="let file of lcdFiles" [ngValue]="file.id">
              {{ file.file_name }}
            </option>
          </select>
          <small *ngIf="lcdFiles && lcdFiles.length === 0" class="text-muted">No policy documents found for the provided CPT and payer.</small>
        </div>
        <br/>
        <div class="info-message section-block">
          <i class="fa fa-info-circle"></i>
          <span>
            If the appropriate document for the selected payer and CPT code is not found in the list, or if there are no policy documents available at all, please upload the relevant policy document by clicking
            <button type="button" class="btn btn-link p-0 align-baseline" (click)="openUploadModal()" style="color:rgb(43, 127, 244);">HERE</button>.
          </span>
        </div>
        <div *ngIf="infoMessages && infoMessages.length" class="info-message section-block mt-2">
          <i class="fa fa-info-circle"></i>
          <div>
            <div *ngFor="let msg of infoMessages">{{ msg }}</div>
          </div>
        </div>
      </div>
     

      <div class="section-block">
        <div class="section-header">
          <i class="fas fa-file-upload"></i>
          <span>Upload Medical Record(s)</span>
        </div>
        <div class="upload-label">
          <input
            #ortFileInput
            type="file"
            (change)="onOrtsSelected($event)"
            accept=".txt,.doc,.pdf"
            multiple
            style="display: none"
          />
          <span class="upload-btn" (click)="ortFileInput.click()">
            <i class="fas fa-file"></i> Choose Medical Record(s)
          </span>
          <ng-container *ngIf="ortMasters && ortMasters.length">
            <span class="file-name" *ngFor="let file of ortMasters; let i = index">
              {{  file?.date ? (file.date | date:'yyyy-MM-dd') : file.name }}
              <button type="button" class="remove-file-btn" (click)="removeOrtMaster(i)">&times;</button>
            </span>
          </ng-container>
        </div>
      </div>

      <div class="section-block">
        <div class="section-header">
          <i class="fas fa-lightbulb"></i>
          <span>Prompt </span>
        </div>
        <div class="prompt-section">
          <textarea
            [(ngModel)]="prompt"
            (ngModelChange)="onPromptChange($event)"
            placeholder="Enter additional prompt instructions here..."
            rows="8"
            class="prompt-textarea"
          ></textarea>
          <small class="form-text text-muted">
            <i class="fas fa-info-circle"></i>
            Prompt should include the following variables for the AI model to work properly:
            <br>
             <code>${{ '{' }}ortMasters{{ '}' }}</code>, <code>${{ '{' }}cptCode{{ '}' }}</code>, <code>${{ '{' }}PolicyContent{{ '}' }}</code>
          </small>

          <div class="button-container">
            <div style="display: flex; gap: 10px;">
              <button
                class="btn btn-primary generate-btn"
                (click)="generateResponse()"
                [disabled]="isLoading"
              >
                <span *ngIf="!isLoading">Check Coverage</span>
                <span *ngIf="isLoading">Generating...</span>
              </button>
              <button
                class="btn btn-success"
                [disabled]="!isPromptChanged"
                (click)="savePrompt()"
              >
                Save Prompt
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vr"></div>

    <div class="half-width">
      <div class="modal-body">
        <div *ngIf="isLoading" class="loading-message">
          <h5>Response Loading Please Wait...</h5>
        </div>
        <div
          *ngIf="!isLoading && !parsedData && !doctorNotes"
          class="no-content"
        >
          <h5>Generated response will appear here</h5>
        </div>

        <div *ngIf="!isLoading && parsedData" class="response-section">
          <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:10px;">
            <h5 style="margin:0;">Response</h5>
            <!-- <button class="btn btn-outline-primary btn-sm" (click)="downloadPdfForSection()">
              <i class="fa fa-download"></i> Download PDF
            </button> -->
          </div>

          <div #docRef class="document-container" style="background:#fff; border:1px solid #e9ecef; border-radius:8px; padding:16px; box-shadow:0 1px 2px rgba(0,0,0,0.03);">
            <!-- Patient Info -->
            <div class="patient-meta" style="font-size:0.95rem; color:#495057; display:flex; flex-wrap:wrap; gap:12px; margin-bottom:12px;">
              <span *ngIf="orderDeatils?.unique_patient?.med_rec_nbr"><strong>MRN:</strong> {{orderDeatils?.unique_patient?.med_rec_nbr}}</span>
              <span *ngIf="orderDeatils?.unique_patient?.first_name && orderDeatils?.unique_patient?.last_name"><strong>Name:</strong> {{orderDeatils?.unique_patient?.first_name}} {{orderDeatils?.unique_patient?.last_name}}</span>
              <span *ngIf="orderDeatils?.ai_order_insurance?.member_id"><strong>Member ID:</strong> {{orderDeatils?.ai_order_insurance?.member_id}}</span>
              <span *ngIf="orderDeatils?.ai_order_insurance?.insurance_plan"><strong>Plan:</strong> {{orderDeatils?.ai_order_insurance?.insurance_plan}}</span>
            </div>

            <hr style="margin: 10px 0;" />

            <!-- ORT Masters Section with pagination -->
            <div class="doc-section">
              <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:6px;">
                <h6 style="margin:0;">Clinicals</h6>
                <div class="pager" *ngIf="ortMasters?.length > 0" style="display:flex; align-items:center; gap:8px;">
                  <button class="btn btn-sm btn-light" (click)="prevOrtPage()" [disabled]="currentOrtPage <= 1">Prev</button>
                  <span style="font-size:0.85rem; color:#6c757d;">Page {{ currentOrtPage }} of {{ totalOrtPages }}</span>
                  <button class="btn btn-sm btn-light" (click)="nextOrtPage()" [disabled]="currentOrtPage >= totalOrtPages">Next</button>
                </div>
              </div>

              <ng-container *ngIf="ortMasters && ortMasters.length; else noOrt">
                <div class="ort-page" *ngFor="let file of ortMasters | slice: ((currentOrtPage-1)*ortPageSize) : (currentOrtPage*ortPageSize); let i = index" style="border:1px solid #f1f3f5; border-radius:6px; padding:10px; background:#fafbfc;">
                  <div style="font-size:0.8rem; color:#6c757d; margin-bottom:6px;">Medical Record {{ ((currentOrtPage-1)*ortPageSize)+i+1 }} of {{ ortMasters.length }}</div>
                  <pre style="max-height:60vh; overflow:auto; white-space:pre-wrap; word-break:break-word; background:#fafbfc; border:1px solid #e9ecef; border-radius:6px; padding:12px; margin:0;">{{ file.master_notes }}</pre>
                </div>
              </ng-container>
              <ng-template #noOrt>
                <div class="text-muted" style="font-size:0.9rem;">No Medical Records available.</div>
              </ng-template>
            </div>

            <hr style="margin: 12px 0;" />

            <!-- Description Section -->
            <div class="doc-section">
              <h6 style="margin-bottom:6px;">Medical Necessity Summary</h6>
              <pre class="response-text ai-response-pre" style="max-height:60vh; overflow:auto; white-space:pre-wrap; word-break:break-word; background:#fafbfc; border:1px solid #e9ecef; border-radius:6px; padding:12px; margin:0;">
{{ parsedData.Description }}
              </pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
